// @flow
import './Breadcrumb.css';

import * as React from 'react';
import _ from 'lodash';
import StoreListener from '../store/StoreListener';
import { PWD, BREADCRUMB_ASSETS, SHOW_ALL_FILES, ALL_FILES_OPTION } from '../store/Constants';
import { ZmCollection, RepoItem } from '../autogenerated/ZoomBridge';
import Button from './Button';
import ViewUtil from '../ViewUtil';
import AssetListCache from '../queries/asset/AssetListCache';
import Store from '../store/Store';
import t from '../i18n/I18n';
import { ThemeSetup } from '../themes/ThemeSetup';


const debug = require('../debug/debug')('wc:common:Breadcrumb');

type Props = {
  collection?: ZmCollection,
  PWD?: number[],
  BREADCRUMB_ASSETS?: RepoItem[],
  showFolderNavView : boolean
};

const storeItems = [PWD, BREADCRUMB_ASSETS];
//$FlowFixMe
@StoreListener(storeItems)
export default class Breadcrumb extends React.Component<Props> {
  _assetCache: AssetListCache = undefined;

  constructor(props) {
    super(props);
    this._assetCache = AssetListCache.getInstance();
  }

  componentDidMount() {
    // this.fetchAssets(this.props.PWD);
    this.fetchAssets(ViewUtil.getPwd());
  }

  componentDidUpdate(prevProps: Props) {
    const pwd = this.props.PWD;
    if (!_.isEqual(pwd, prevProps.PWD)) {
      this.fetchAssets(pwd);
    }
  }

  fetchAssets = async (fuids: number[] = []) => {
    try {
      if (!(fuids && fuids.length)) {
        if (_.size(this.props.BREADCRUMB_ASSETS) > 0) {
          Store.put(BREADCRUMB_ASSETS, []);
        }
        return;
      }

      let parentFuid = 0;
      const promises = fuids.map((fuid: number, i: number) => {
        const promise = this.fetchAsset(parentFuid, fuid, i);
        parentFuid = fuid;
        return promise;
      });

      let assets = await Promise.all(promises);
      assets = _.compact(assets);

      const resultFuids = assets.map((a) => a.getFuid());
      if (!_.isEqual(fuids, resultFuids)) {
        debug('[fetchAssets()] mismatch between fuids and resultFuids: ', { fuids, resultFuids });
        debug('[fetchAssets()] setting pwd: ', resultFuids);
        ViewUtil.setPwd(resultFuids);
      }

      debug('[fetchAssets()] assets: ', assets);
      Store.put(BREADCRUMB_ASSETS, assets);
    } catch (err) {
      debug('[fetchAssets()] error: ', err);
    }
  };

  fetchAsset = async (parentFuid: number, fuid: number, i: number): RepoItem => {
    debug(`[fetchAsset() ${i}] args: `, { parentFuid, fuid });

    // We already have the target fuid but the backend requires us to run
    // ListFilesQuery before we can run GetAssetsInfoQuery.
    // const fuids = await this._assetCache.fetchFuids(parentFuid, {
    //   /* force: true, nocache: true */
    // }); // nocache because some case it cache fuids for display assets.
    // if (!fuids.includes(fuid)) {
    //   debug(`[fetchAsset() ${i}] parent folder ${parentFuid} does not contain asset ${fuid}`);
    //   return null;
    // }

    const assets = await this._assetCache.getOrFetchRepoItems(parentFuid, [fuid]);
    const asset = assets.find((a) => a.getFuid() === fuid);
    debug(`[fetchAsset() ${i}] asset: `, asset);

    return asset;
  };

  onBaseClick = () => {
    ViewUtil.setPwd(null);
  };

  onClick = (i: ?number) => {
    ViewUtil.popPwd(i);
  };

  renderCrumb = (fuid: number, label: string, i: ?number) => {
    //const { PWD: pwd = [], collection } = this.props;
    const { collection } = this.props;
    const pwd = ViewUtil.getPwd();
    const isLast = i === pwd.length - 1;
    const props: Object = {
      key: fuid,
      className: 'crumb',
      icon: isLast || collection ? ThemeSetup.getImageURL('folder_open_black.svg') : 'images/folder_open_gray.svg'
    };

    if (!isLast) {
      props.onClick = () => this.onClick(i);
    }
    return (
      <div className= 'crumb' onClick={props.onClick} key={fuid + 'crumb'}>
        <div className='crumb-icon'><img src={props.icon}></img></div>
        <div className='crumb-label'>{label}</div>
      </div>
    )
    return <Button {...props}>{label}</Button>;
  };

  renderCrumbs = () => {
    // const { PWD: pwd = [], BREADCRUMB_ASSETS: assets } = this.props;
    const { BREADCRUMB_ASSETS: assets } = this.props;
    const pwd = ViewUtil.getPwd();
    const crumbs = pwd.map((fuid, i) => {
      const asset: RepoItem = assets ? assets.find((a) => a.getFuid() === fuid) : null;
      if (!asset) {
        return [];
      }

      const sep = (
        <span key={-i - 1} className="separator">
          <img src="images/arrow_down.svg" />
        </span>
      );

      const crumb = this.renderCrumb(fuid, asset.getName(), i);

      return [sep, crumb];
    });

    return _.flatten(crumbs);
  };

  render() {
    //const { collection, PWD: pwd = [] } = this.props;
    const { collection, showFolderNavView } = this.props;
    const pwd = ViewUtil.getPwd();
    const baseProps: Object = {
      className: 'base',
      onClick: this.onBaseClick
    };
    const base = (
      <span {...baseProps}>
        {collection
          ? collection.getName()
          : Store.get(ALL_FILES_OPTION) == 'SHOW_ALL_FILES' 
          ? t('ALL_FILES')
          : t('ASSETS')}
      </span>
    );
    if (!pwd.length || !showFolderNavView) {
      return (
        <div name="Breadcrumb" className="single">
          {base}
        </div>
      );
    }

    return (
      <div name="Breadcrumb">
        {base}
        {this.renderCrumbs()}
      </div>
    );
  }
}
